import axios from "axios";
import {
  getProjectSpecialStatusAPI,
  getExecutersAPI,
  getProjectStatusAPI,
  queryProjectOperationsAPI,
  getProjectStatusByIdAPI,
} from "./api";

const initState = {
  pageRoute: {},
  pageList: [],
  workFlowStatus: true,
  loading: false,
  hasPermission: true,

  isRoot: false,
};

const newState = {
  isRoot: false,
};

let state = {
  ...initState,
  ...newState,
  projectStatus: {
    editProject: 0,
    createProjectEcr: 0,
    pauseOrNotOperation: 1,
  },
  taskStatus: {
    statusInfo: {},
  },
  statusInfo: [],
  lightInfo: {},
};

const mutations = {
  SET_PAGEROUTE: (state, data) => {
    state.pageRoute = data;
  },

  CLEAR: () => {
    state = { ...initState };
  },

  SET_PROJCET_STATUS_INFO: (state, data) => {
    const { lightInfo, ...obj } = data;
    state.statusInfo = { ...obj };
    state.lightInfo = lightInfo;
  },

  SET_TASK_STATUS: (state, data) => {
    state.taskStatus = { ...data };
  },

  SET_PROJCET_ECR: (state, data) => {
    state.projectStatus = { ...data };
  },
  CLEAR_TASK: (state) => {
    state.projectStatus = {
      id: "",
      statusInfo: {},
    };
  },
};

const actions = {
  async getWorkFlowStatus({ commit }, param) {
    const { id, classId, subClassId } = param;

    const taskList = [
      getProjectSpecialStatusAPI(id),
      getExecutersAPI({ id, classId, subClassId }),
      getProjectStatusAPI(id),
      getProjectStatusByIdAPI(id),
    ];

    const res = await Promise.all(taskList);
    console.log("project init actions", res);
    const [
      { specialProjectVo },
      { executers = [] },
      { currectStatus, projectStatusList },
      { Info: lightInfo },
    ] = res.map((i) => i.data.object);

    console.log("init data", {
      specialProjectVo,
      executers,
      currectStatus,
      projectStatusList,
    });
    commit("SET_PROJCET_STATUS_INFO", {
      specialProjectVo,
      executers,
      currectStatus,
      projectStatusList,
      lightInfo,
    });
  },

  async queryTaskStatus({ commit, state }, param) {
    const { id, classId, subClassId } = param;

    console.log(state.taskStatus, id);

    // if (state.taskStatus.id === id) {
    //   return;
    // }

    const taskList = [
      getProjectSpecialStatusAPI(id),
      getExecutersAPI({ id, classId, subClassId }),
      getProjectStatusAPI(id),
    ];

    const res = await Promise.all(taskList);
    console.log("project init actions", res);
    const [
      { specialProjectVo },
      { executers = [] },
      { currectStatus, projectStatusList },
    ] = res.map((i) => i.data.object);

    commit("SET_TASK_STATUS", {
      id,
      statusInfo: {
        specialProjectVo,
        executers,
        currectStatus,
        projectStatusList,
      },
    });
  },

  async queryProjectChange({ commit }, param) {
    const { id } = param;
    queryProjectOperationsAPI(id).then((res) => {
      const { ...obj } = res.data.object;
      // console.log({ editProject, createProjectEcr, pauseOrNotOperation });
      commit("SET_PROJCET_ECR", obj);
    });
  },
  clear({ commit }) {
    // commit("CLEAR");
    console.log("CLEAR");
  },
  clearTask({ commit }) {
    commit("CLEAR_TASK");
  },
};

const getters = {
  getPriv(state, getters, rootState, rootGetters) {
    const { currectStatus, executers, specialProjectVo } = state.statusInfo;
    const { statusType } = currectStatus,
      { specialState } = specialProjectVo;
    const editByStatusType = ![3, 4].includes(statusType),
      hasProjectPause = specialState !== 0;
    const currentUser = +window.sessionStorage.getItem("currentUserId");
    const projectAdministrators = rootGetters["project/getProjectDirectors"];
    const isAdministrator = projectAdministrators.includes(currentUser);

    const isExecuter = executers.map((i) => i.id).includes(currentUser);

    const { editProject } = state.projectStatus;

    return {
      editProject,
      isAdministrator,
      isExecuter,
      editByStatusType,
      hasProjectPause,
    };
  },
  getProjectLight(state) {
    return state.lightInfo;
  },
  getCreateEcrInfo(state) {
    return state.projectStatus;
  },
  getProjectInfo(state) {
    return state.statusInfo;
  },
  getProjectPauseStatus(state) {
    return state.statusInfo.specialProjectVo;
  },
  getTaskStatus(state) {
    return state.taskStatus;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
